<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="print"/>
          {{ $t('printTemplate') }}
        </h1>
      </div>
    </div>
    <print-template-list></print-template-list>
  </main>
</template>

<script>
import PrintTemplateList from "@/views/order/PrintTemplateList.vue";

export default {
  components: {PrintTemplateList},
  data() {
    return {}
  },
  i18n: {
    messages: {
      en: {
        printTemplate: 'Print template',
      },
      vi: {
        printTemplate: 'Mẫu in',
      }
    }
  },
}
</script>